import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useParams } from 'react-router-dom';
import { Button, Result } from 'antd';
import usePortalService from '../../services/PortalService';
 
export default function ConfirmEmail() {
    const {confirmLink} = usePortalService();

    const navigate = useNavigate();

    const params = useParams();
    const confirmString = params.confirmString;

    const [confirmed, setConfirmed] = useState(false)
    const [error, setError] = useState()

    const confirmHandle = async () => {
        const result = await confirmLink({
            link: confirmString
        });
        if (result.success) {
            setConfirmed(true)
        } else {
            setError(result.errors)
        }
    }

    useEffect(() => {
        confirmHandle();
    }, [])

    if (error) {
        return (
            <div className="center-of-screen-container">
                <Result
                status="error"
                title={error}
                extra={[
                    <Button type="primary" onClick={() => navigate('/')} key="back">
                        На главную
                    </Button>,
                ]}
                />
            </div>
        )
    }
    if (confirmed) {
        return (
            <div className="center-of-screen-container">
                <Result
                status="success"
                title="Адрес электронной почты подтверждён"
                extra={[
                    <Button type="primary" onClick={() => navigate('/')} key="back">
                        На главную
                    </Button>,
                ]}
                />
            </div>
        )
    } else return (
        <div className="center-of-screen-container">
            <Spin size="large">
                <div className="content" />
            </Spin>
            <h3 style={{marginTop:'50px'}}> Подтверждение адреса электронной почты </h3>
        </div>
    );
};